<!-- 开票信息列表 -->
<template>
  <div class="billingInformation" v-loading="loading">
    <div class="header">
      <Search
        :tableSearch="tableSearch"
        @handleSearch="handleSearch"
        :valueFormat="valueFormat"
        ref="search"
      />
    </div>
    <div class="footer">
      <Rectangle :path="require('@/assets/img/common/rectangle.png')" />
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <TipsLabel :tip="'总条数统计：'" :count="page.total.toString()" />
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-bottom: 12px;
          "
        >
          <iconBtn
            @btnClick="downLoad"
            :name="'批量下载'"
            :path="require('@/assets/img/common/modify.png')"
            :width="100"
            style="margin-right: 10px"
          />
          <iconBtn
            @btnClick="exportData"
            :name="'导出'"
            :path="require('@/assets/img/common/modify.png')"
            :width="70"
          />
          <iconBtn
            :name="'导入快递单号'"
            :path="require('@/assets/img/common/modify.png')"
            style="margin-left: 10px"
            :width="130"
            @btnClick="isShow = true"
          />
          <iconBtn
            @btnClick="syncInvoice"
            :path="require('@/assets/img/common/modify.png')"
            :name="'同步发票'"
            :width="130"
            style="margin-left: 10px"
          />
        </div>
      </div>

      <Table
        :tableProp="tableProp"
        :tableData="tableData"
        :ishandle="true"
        :isOrderNo="true"
        :isSection="true"
        :operateArray="['edit', 'down']"
        :width="120"
        :orderWidth="55"
        @SelectionChange="SelectionChange"
      >
        <span
          slot-scope="scope"
          slot="edit"
          v-if="scope.row.kpzt == '已开票' && scope.row.fpzl == '电子普票'"
          @click="handleEdit(scope.index, scope.row)"
          style="
            color: #1b5bbf;
            width: 30px;
            padding: 0 5px;
            cursor: pointer;
            margin-right: 10px;
          "
          >详情</span
        >
        <span
          slot="edit"
          v-else
          style="
            width: 30px;
            padding: 0 5px;
            margin-right: 10px;
            cursor: default;
          "
          >--</span
        >
      </Table>
      <Pagination
        :page="page"
        @setcurrentpage="handleCurrentChange"
        v-if="tableData.length > 0"
      ></Pagination>
    </div>

    <el-dialog
      title="导入快递单号文件"
      :visible.sync="isShow"
      width="25%"
      :close-on-click-modal="false"
    >
      <div class="downBox">
        <el-link :href="`${$BASEURL}/bds/publicrs/image/transportOrder`"
          >模板下载</el-link
        >
        <el-upload
          :action="`${$BASEURL}/op/feemanage/invoiceimportexpno`"
          :on-success="importSuccess"
          :http-request="myUploadMethod"
          :before-upload="beforeSize"
          :show-file-list="false"
          :file-list="fileList"
          :auto-upload="true"
          name="file"
        >
          <el-button type="text">导入运单号</el-button>
        </el-upload>
      </div>
      <div style="width: 100%; display: flex; justify-content: center">
        <el-button type="primary" @click="isShow = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Search from "@/components/public/Element/formSearch.vue";
import Rectangle from "@/components/public/Element/rectangle.vue";
import TipsLabel from "@/components/public/Element/tipsLabel.vue";
import Table from "@/components/public/Element/ElTable.vue";
import iconBtn from "@/components/public/Element/ELIconButton.vue";
import Pagination from "@/components/public/Element/Pagination.vue";

export default {
  name: "cashApproved",
  components: {
    Search,
    Rectangle,
    TipsLabel,
    Table,
    iconBtn,
    Pagination,
  },
  data() {
    return {
      isShow: false,
      loading: false,
      valueFormat: "yyyy-MM-dd",
      tableSearch: [
        {
          label: "发票类型",
          value: "fpzl",
          type: "select",
          children: [
            {
              label: "专票",
              value: "0",
            },
            {
              label: "电子普票",
              value: "51",
            },
          ],
        },
        {
          label: "发票号码",
          value: "fph",
          type: "text",
        },
        {
          label: "发票代码",
          value: "fpdm",
          type: "text",
        },
        {
          label: "企业名称",
          value: "gfmc",
          type: "text",
        },
        {
          type: "date",
          label: "开票日期",
          apply: "date",
          children: [
            {
              value: "startDate",
              type: "startDate",
            },
            {
              value: "endDate",
              type: "endtDate",
            },
          ],
        },
        {
          label: "发票状态",
          value: "kpzt",
          type: "select",
          children: [
            {
              label: "开票中",
              value: "1",
            },
            {
              label: "已开票",
              value: "2",
            },
            {
              label: "开票失败",
              value: "3",
            },
            {
              label: "已作废",
              value: "4",
            },
          ],
        },
        {
          label: "收费环节",
          value: "sfhj",
          type: "select",
          children: [
            {
              label: "转单",
              value: "ZD",
            },
            {
              label: "融资",
              value: "RZ",
            },
          ],
        },
        {
          label: "销售单据编号",
          value: "xsdjbh",
          type: "text",
        },
      ],
      tableProp: [
        {
          code: "xsdjbh",
          label: "销售单据编号",
        },
        {
          code: "fph",
          label: "发票号码",
          minWidth: 180,
        },
        {
          code: "fpdm",
          label: "发票代码",
          minWidth: 160,
        },
        {
          code: "gfmc",
          label: "企业名称",
          minWidth: 180,
        },
        {
          code: "fpje",
          label: "发票金额(含税)",
          minWidth: 150,
        },
        {
          //TODO 待后台返回
          code: "yssl",
          label: "应税税率(%)",
          minWidth: 100,
        },
        {
          //TODO 待后台返回
          code: "ysse",
          label: "应税税额",
          minWidth: 150,
        },
        {
          code: "fpzl",
          label: "发票类型",
          minWidth: 100,
        },
        {
          code: "sfhj",
          label: "收费环节",
          minWidth: 160,
        },
        {
          code: "kpzt",
          label: "发票状态",
          minWidth: 100,
        },
        {
          code: "kjrq",
          label: "开票日期",
          minWidth: 150,
        },
        {
          code: "ydh",
          label: "运单号",
          minWidth: 160,
        },
      ],
      tableData: [],
      page: {
        total: 0,
        currentPage: 1,
        size: 10,
      },
      fileList: [],
      exportFileLoading: false,
      downParams: [],
      selectTableData: [],
      xsdjbhsArr: [],
    };
  },
  created() {},
  methods: {
    myUploadMethod(file) {
      this.$UPLOAD("/op/feemanage/invoiceimportexpno", file.file).then(
        (res) => {
          if (res.ret == 0) {
            if (res.data.code == "200") {
              this.$message.success(res.msg);
              this.isShow = false;
            } else {
              this.isShow = false;
              this.$DLMessageBox({
                type: "warn",
                title: "请重新操作",
                content: `<div class="red">${res.data.message}！</div>`,
              });
            }
          } else {
            this.isShow = false;
            this.$message.error(res.msg);
          }
        }
      );
    },

    beforeSize(file) {
      console.log("文件类型", file.type);
      const isLt1M = file.size / 1024 / 1024 < 20;
      if (
        !(
          file.type ==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        )
      ) {
        // this.$message.error("文件类型只限于：.xlsx");
        this.isShow = false;
        this.$DLMessageBox({
          type: "warn",
          title: "请重新操作",
          content: `<div class="red">请导入excel文档！</div>`,
        });
        return false;
      }
      if (!isLt1M) {
        this.$message.error("上传文件大小不能超过 5MB!");
        return isLt1M;
      }
    },
    importSuccess(res, file, fileList) {
      if (res.ret == "0") {
        this.$message.success("导入数据成功！");
        this.isShow = false;
      } else {
        this.$message.warning(res.msg);
      }
    },

    //同步发票
    syncInvoice() {
      if (!this.selectTableData.length > 0) {
        this.$message.warning("请选择发票数据！");
        return;
      }
      let flag = this.selectTableData.every((item) => {
        return item.kpzt == "开票中";
      });
      let params = {
        xsdjbhs: this.xsdjbhsArr,
      };
      if (flag) {
        this.$POST("/op/feemanage/getsaleorderinfo", params).then((res) => {
          if (res.ret == "0") {
            let msg = [];
            res.data.forEach((item) => {
              if (item.code == "500") {
                return msg.push(item.xsdjbh + ":" + item.msg);
              }
            });
            //错误原因提示换行
            let newDatas = [];
            const h = this.$createElement;
            for (let i in msg) {
              newDatas.push(h("p", null, msg[i]));
            }
            if (msg.length > 0) {
              this.$msgbox({
                title: "同步发票失败原因：",
                type: "warn",
                customClass: "DLMessageBox",
                message: h("div", null, newDatas),
              });
            } else {
              this.$DLMessageBox({
                type: "success",
                title: "同步成功！",
                content: "",
              });
            }

            this.getQueryList();
          }
        });
      } else {
        this.$message.warning("请选择开票中的数据进行操作！");
        this.selectTableData = [];
      }
    },
    // 接收的事件
    handleSearch(val) {
      this.getQueryList(val);
    },
    handleEdit(index, row, item) {
      console.log(index, row, item);
      this.$router.push({
        name: "invoiceCenterDetail",
        params: {
          row: row,
        },
      });
    },

    exportData() {
      //导出
      console.log("导出");
      const parameters = {
        fph: this.fphString,
      };
      let flag = this.selectTableData.every((item) => {
        return item.kpzt == "已开票";
      });
      if (!parameters.fph) {
        this.$message.warning("请选择数据导出！");
        return;
      }
      if (!flag) {
        this.$message.warning("请选择已开票的数据导出！");
        return;
      }
      let url = `/op/feemanage/invoiceexport`;
      this.$exportFileFunc(
        "已开发票信息报表",
        ".xlsx",
        url,
        "post",
        parameters
      );
    },

    //批量下载
    downLoad() {
      if (this.selectTableData.length > 0) {
        const url = this.$BASEURL + `/bds/publicrs/image/zip`;
        let flagSelect = this.selectTableData.every((item) => {
          return item.kpzt == "已开票" && item.fpzl == "电子普票";
        });
        if (flagSelect) {
          this.$exportFileFunc(
            "发票管理批量下载",
            ".zip",
            url,
            "post",
            this.downParams
          );
        } else {
          this.$message.warning("请选择已开票状态的普票进行下载");
        }
      } else {
        this.$message.warning("请选择下载数据！");
      }
    },
    //查询已开发票列表)
    getQueryList(val) {
      this.loading = true;
      let params = {
        page: this.page.currentPage,
        pageSize: this.page.size,
      };
      if (val) {
        params = {
          page: this.page.currentPage,
          pageSize: this.page.size,
          fpzl: val.fpzl,
          fph: val.fph,
          fpdm: val.fpdm,
          gfmc: val.gfmc,
          startDate: val.startDate,
          endDate: val.endDate,
          kpzt: val.kpzt,
          sfhj: val.sfhj,
          xsdjbh: val.xsdjbh,
        };
      }
      console.log(params);
      let status = ["", "开票中", "已开票", "开票失败", "已作废"];
      this.$POST("/op/feemanage/invoicelistquery", params).then((res) => {
        this.loading = false;
        if (res.ret == "0") {
          if (res.data.content) {
            let sfhjState = {
              ZD: "转单",
              RZ: "融资",
            };
            //数据字典
            res.data.content.map((item) => {
              switch (item.fpzl) {
                case "0":
                  item.fpzl = "专票";
                  break;
                case "51":
                  item.fpzl = "电子普票";
                  item.ydh = "--";
                  break;
                default:
                  break;
              }
              // item.kpzt = item.kpzt == "0" ? "未开票" : "已开票";
              item.kpzt = status[item.kpzt];
              item.kjrq = this.time2date(item.kjrq);
              item.ysse = this.$utif.moneyFLoatFormat(item.ysse);
              item.fpje = this.$utif.moneyFLoatFormat(item.fpje);
              item.sfhj = sfhjState[item.sfhj];
            });
            this.tableData = res.data.content;
            this.page.total = res.data.totalElements;
            this.page.currentPage = res.data.pageNumber;
          } else {
            this.$message.warning("暂无数据！");
            this.tableData = [];
            this.page.total = res.data.totalElements;
          }
        } else {
          // this.$message.warning(res.msg);
          this.tableData = [];
        }
      });
    },

    //获取选中表格数据
    SelectionChange(val) {
      this.fphString = "";
      this.downParams = [];
      this.xsdjbhsArr = [];
      this.selectTableData = [];
      val.forEach((item) => {
        this.fphString += item.fph + ",";
        this.downParams.push(item.wjid);
        this.xsdjbhsArr.push(item.xsdjbh);
      });
      this.selectTableData = val;
    },

    handleCurrentChange(val) {
      console.log(`当前页page${val}`);
      this.page.currentPage = val;
      let s = this.$refs.search.formSearch||{};
      this.getQueryList(s);
    },
  },
};
</script>

<style lang="less" scoped>
.billingInformation {
  background-color: #f8f8f8;
}

.downBox {
  padding: 0 20%;
  display: flex;
  justify-content: space-between;
}
.header {
  margin-top: 8px;
  /* padding: 32px 38px 39px 48px; */
  background-color: #fff;
  width: auto;
}

.footer {
  margin-top: 13px;
  padding-top: 13px;
  padding: 16px 48px 0px;
  background-color: #fff;
  // height: 400px;
  width: auto;
  .tip {
    margin-top: 12px;
    margin-bottom: 18px;
    line-height: 1.5;
  }
}
</style>